export default {
	MUTATIONS: {
		/**
		 * formErrors
		 */
		PUSH_ERRORS: 'push_errors',
		CLEAR_ERRORS: 'clear_errors'
	},
	DEFAULT_ERROR_FIELD: 'default'
}


// WEBPACK FOOTER //
// ./resources/js/constants.js